<ng-container *ngIf="loaded">
  <h1>Select an investment profile</h1>
  <ng-container *ngIf="selectedEntity">
    <h2 class="currently-selected-header">Currently Selected</h2>
    <p>
      The following profile is currently selected for this investment. You can also choose
      from your other profiles, or add a new one to invest with.
    </p>

    <div class="current-investment-profile card-layout">
      <header>
        <h3>{{selectedEntity.display_name}}</h3>
        <h5 *ngIf="selectedEntity.draft">Draft</h5>
      </header>

      <ul class="data-list">
        <li>
          <h5>Entity Type</h5>
          {{selectedEntity.entity_type_humanized || '–'}}
        </li>
        <li>
          <h5>Investor Type</h5>
          {{selectedEntity.investment_account.investment_type_humanized || '–'}}
        </li>
      </ul>

      <hr class="profile-detail-divider">

      <ul class="totals-list">
        <li>
          <h5>Deals/Investments</h5>
          {{selectedEntity.investment_account.total_investments || '–'}}
        </li>

        <li>
          <h5>Total Invested</h5>
          {{selectedEntity.investment_account.total_invested || '–'}}
        </li>
      </ul>

      <button
        (click)="selectInvestmentProfile(selectedEntity)"
        [disabled]="isSubmitting$ | async"
        class="confirm-profile"
        type="button"
      >
        Continue with Selection
      </button>
    </div>
    <div class="or-seperator">
      <span>or</span>
    </div>
  </ng-container>
   
  <ng-container *ngIf="showEntitySelector && investorMatchesCurrentUser">    
    <h2 class="available-entities-header">Available Profiles</h2>
    <fl-entity-selector
      [entities]="selectableEntities"
      [showDraftStatus]="true"
      (entitySelected)="onSelectInvestmentProfile($event)"
      [vehicle]="vehicle"
    ></fl-entity-selector>
    <div class="or-seperator">
      <span>or</span>
    </div>
  </ng-container>

  <!-- User is acting on behalf of the owner -->
  <ng-container *ngIf="showEntitySelector && !investorMatchesCurrentUser">
    <ng-container *ngIf="selectableEntitiesWithUserAndInvestor.length">
      <h2 class="available-entities-header">Investor Profiles</h2>
      <p *ngIf="{investor: investorDetails$ | async, user: user$ | async} as data">
        @if (data.investor.name && data.user.name) {
          These investor profiles are managed by the investor
          <strong>{{ data.investor.name }}</strong> and you,
          <strong>{{ data.user.name }}</strong>.
        }
      </p>
      <fl-entity-selector
        [entities]="selectableEntitiesWithUserAndInvestor"
        [showDraftStatus]="true"
        (entitySelected)="onSelectInvestmentProfile($event)"
        [vehicle]="vehicle"
      ></fl-entity-selector>
    </ng-container>
    <ng-container *ngIf="selectableEntitiesWithUserButWithoutInvestor.length">
      <h2 class="available-entities-header">Additional Profiles</h2>
      <p *ngIf="{investor: investorDetails$ | async, user: user$ | async} as data">
        <!-- TODO: expand message to include automatically adding, when supported -->
        @if (data.investor.name && data.user.name) {
          These investor profiles are managed by you, <strong>{{ data.user.name }}</strong>, but
          do not contain the investor.
        }
      </p>
      <fl-entity-selector
        [entities]="selectableEntitiesWithUserButWithoutInvestor"
        [showDraftStatus]="true"
        (entitySelected)="onSelectInvestmentProfile($event)"
        [vehicle]="vehicle"
      ></fl-entity-selector>
    </ng-container>
    <div class="or-seperator">
      <span>or</span>
    </div>
  </ng-container>

  <section class="new-investment-profile card-layout" *ngIf="showEntitySelector; else addInvestmentProfile">
    <div class="new-profile-text">
      <h4>Don’t see the profile you want to invest through?</h4>
    </div>
    <button [disabled]="isSubmitting$ | async" class="confirm-profile" (click)="createNewInvestmentProfile()" type="button">
      Add Investment Profile
    </button>
  </section>

  <ng-template #addInvestmentProfile>
    <div class="expanded-new-investment-profile card-layout">
      <h2>Don’t see the entity you want to invest through?</h2>
      <p>Add an investment profile to Flow.</p>
      <button [disabled]="isSubmitting$ | async" class="confirm-profile" (click)="createNewInvestmentProfile()" type="button">
        Add Investment Profile
      </button>
    </div>
  </ng-template>
</ng-container>
